{
  "title": "LUCKY WHEEL",
  "description": "Try your luck every day!",
  "available": "Today's free spin is ready!",
  "spin": "🎡 SPIN",
  "spinning": "The wheel is spinning...",
  "winTitle": "Congratulations!",
  "win": "You won {{amount}} AZN bonus!",
  "used": "🎁 You've used today's spin! Come back tomorrow!",
  "homeCta": "Tap the wheel and try your luck",
  "homeUsed": "Come back tomorrow!",
  "ribbonReady": "TRY YOUR LUCK",
  "ribbonUsed": "COME BACK TOMORROW",
  "hubSpin": "SPIN",
  "sheetHint": "Tap the wheel and try your luck",
  "winAmount": "YOU WON {{amount}} AZN!",
  "closeResult": "Close",
  "demoBadge": "Visual demo — real bonus credits are not active yet",
  "loginRequiredBadge": "Sign in to claim a real bonus",
  "loginRequired": "Sign in to use the real Lucky Wheel.",
  "demoWinNote": "This is a visual result only. No bonus balance was credited.",
  "testBadge": "WEBSITE TEST MODE — TEST BONUS, not withdrawable",
  "testWinNote": "{{amount}} AZN TEST BONUS was credited. This is not withdrawable and is not added to the real-money balance.",
  "testBalance": "Test bonus",
  "testLedger": "TEST BONUS (not withdrawable)",
  "testNotWithdrawable": "Test funds can never be withdrawn",
  "testExpires": "Test credit expires: {{when}}",
  "testPrize": "Test prize: {{amount}} AZN",
  "mute": "Mute",
  "unmute": "Unmute",
  "close": "Close",
  "openAria": "Open VBB Lucky Wheel",
  "spinFailed": "The spin could not start. Please try again shortly.",
  "wageringTitle": "Bonus wagering",
  "bonusBalance": "Bonus balance",
  "wageringMultiplier": "Requirement",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Wagering target",
  "wageringCompleted": "Completed",
  "wageringRemaining": "Remaining",
  "bonusStatus": "Bonus status",
  "withdrawalEligibility": "Withdrawal",
  "bonusNotWithdrawable": "Bonus funds are not withdrawable until conversion is approved"
}
